import { Map, List } from 'immutable';
import PracticePlayModel from './model';
import { FETCH_PRACTICE_PLAY_SUCCESS } from './actions';

export default function practicePlay(state = new Map(), action) {
  switch (action.type) {
    case FETCH_PRACTICE_PLAY_SUCCESS:
      return state.set(action.groupId, new List(action.payload.map((item) =>
          PracticePlayModel.create(item))));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/PracticePlay/reducer.js